// extracted by css-extract-rspack-plugin
export default {"QueryErrorTitle":"xJ6ff","QueryErrorIcon":"UhVUX","QueryErrorMessage":"xd8iK","QueryErrorLink":"mRyHz"};